<!--
 * @Author: Junjie
 * @Date: 2022-11-20 21:25:57
 * @LastEditTime: 2022-12-29 10:44:17
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/report/online/OperateReocrd.vue
-->
<template>
  <div class="page-container" id="allContainer" style="background-color: #fff;">
    <a-button
      :icon="fullscreen ? 'fullscreen-exit' : 'fullscreen'"
      @click="toggleFullscreen"
      style="position: fixed; right: 15%;margin-top: -5px;"
      type="primary"
    >全屏</a-button>
    <div class="flex h-full">
      <div :style="{ width: leftWidth + 'px', backgroundColor: '#fff' }" class="overflow-y-scroll" ref="leftContainer">
        <common-category-tree
          :collapsed.sync="treeCollapsed"
          :pCode="categoryRootCode"
          :renderFilter="renderFilter"
          :title="treeTitle"
          @change="onSelect"
        ></common-category-tree>
      </div>
      <div @mousedown="startResize" class="resize-bar"></div>

      <div :style="{ width: 'calc(100% - ' + leftWidth + 'px - 5px)' }" class="ml-5px">
        <report-tabs />
      </div>
    </div>
  </div>
</template>
<script>
  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  import ReportTabs from './modules/ReportTabs.vue'
  import { mixinDevice } from '@/utils/mixin.js';
  import { getAction } from '@/api/manage';
  import onlineCommons from '@jeecg/antd-online-mini'
  import RouteView from '@/components/layouts/RouteView.vue'
  import CommonCategoryTree from "./modules/CommonCategoryTree";
  const ReportItem = onlineCommons.onlineCommon
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      IframeFReportView, onlineCommons, RouteView, ReportItem, CommonCategoryTree, ReportTabs
    },
    mixins: [mixinDevice],
    data () {
      return {
        name: 'OperateReocrd',
        fullscreen: false,
        iframeSrc: '',
        mainInfoHeight: "100%",
        treeTitle: '运行记录',
        title: '',
        categoryRootCode: 'A02',
        treeCollapsed: false,
        reportPageType: '',
        defaultExpandedKeys: [],
        autoExpandParent: true,
        expandAll: false,
        defaultSelectedKeys: [],

        renderFilter: `!item.cusProp2 || item.cusProp2.indexOf('${this.$ls.get('Login_UserId')}') > -1`,

        leftWidth: 250,
        isResizing: false
      }
    },
    created () {
      this.$nextTick(() => {
        this.fullListen();
      });
    },
    mounted () {
      //   this.mainInfoHeight = (window.innerHeight - 285) + "px";
    },
    computed: {
      ...mapGetters(['permissionList']),

      routerCode () {
        return this.$route.params.code || 0
      }
    },

    methods: {
      ...mapActions({
        addReportTab: 'reportTab/addReportTab',
      }),
      onSelect (treeNode) {
        const url = treeNode.dataRef.cusProp1;
        if (treeNode.dataRef.pid == "0" || !url) {
          return;
        }
        this.selectUrl(treeNode.dataRef);
      },
      selectUrl (treeNode) {
        const url = treeNode.cusProp1;
        // this.iframeSrc = url;
        this.title = treeNode.name;

        this.$store.dispatch('addReportTab', treeNode)
        // const reportPageType = url.indexOf('http') !== -1 ? 'outside' : 'inside'
        // this.reportPageType = reportPageType
        // if (reportPageType == 'inside') {
        //   this.$router.push({
        //     path: this.iframeSrc
        //   })
        // }
      },
      toggleFullscreen () {
        let element = document.getElementById('allContainer');
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {    // 否则，进入全屏
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        // 改变当前全屏状态
        this.fullscreen = !this.fullscreen;
      },
      fullListen () {
        const that = this;
        let screen = document.getElementById("allContainer");
        if (screen.requestFullscreen) {
          document.addEventListener("fullscreenchange", () => {
            if (!!that.getFullscreenElement() !== that.fullscreen) {
              that.toggleFullscreen();
            }
          });
        }
      },
      // 获取全屏状态
      getFullscreenElement () {
        return (
          document['fullscreenElement'] ||
          document['mozFullScreenElement'] ||
          document['msFullScreenElement'] ||
          document['webkitFullscreenElement'] || null
        );
      },
      startResize (event) {
        this.isResizing = true
        document.addEventListener('mousemove', this.handleResize)
        document.addEventListener('mouseup', this.stopResize)
      },
      handleResize (event) {
        if (this.isResizing) {
          const newWidth = event.clientX - this.$refs.leftContainer.getBoundingClientRect().left
          this.leftWidth = newWidth > 200 ? newWidth : 200 // 限制最小宽度为200px
        }
      },
      stopResize () {
        this.isResizing = false
        document.removeEventListener('mousemove', this.handleResize)
        document.removeEventListener('mouseup', this.stopResize)
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .edit-table {
    &-collapsed {
      width: calc(100% - 50px);
    }
    &-full {
      width: calc(100% - 308px);
    }
  }

  .resize-bar {
    width: 2px;
    cursor: ew-resize;
    background-color: #ccc;
    z-index: 1000;
  }
</style>